import ByPublication from './by_publication';

export default ByPublication;
